import { GenericObject } from "utility/misc";

export default function redirectToGoogleSheetPage(
  orgStore: GenericObject,
  navigate: Function
): void {
  navigate("/environment/destinations/google_sheet/connect");
}
